import { ACTIVE, CHANGE_RULES, CONDITIONS, DESCRIPTION, GLOBAL, SEVERITY, SOUND } from '../constants'

const changeRule = (index, property, value, saveState = 'rule') => (dispatch, getState) =>
    dispatch({
        type: CHANGE_RULES,
        changes: [
            {
                index,
                keyVals: { [property]: value },
                saveState: getState().editorReducer.saveState[index] === 'rule' ? 'rule' : saveState
            }
        ]
    })

export const active = (index, active) => changeRule(index, ACTIVE, active)
export const conditions = (index, conditions) => changeRule(index, CONDITIONS, conditions)
export const description = (index, description) => changeRule(index, DESCRIPTION, description)
export const ruleType = (index, global) => changeRule(index, GLOBAL, global)
export const severity = (index, severity) => changeRule(index, SEVERITY, severity)
export const sound = (index, sound) => changeRule(index, SOUND, sound, 'sound')
